import { AssetType, StreamType } from './models/Shared.types';
import {
  IChannelCatalogV5,
  IChannelImagesV5,
  IChannelRightsV5,
  IChannelRightV5,
  IChannelTextsV5,
  IChannelThumbnailV5,
  IChannelV5,
} from './models/AndromeTV.types';
import { Backend } from './Backend';

export class ChannelModel implements IChannelV5 {
  private customerChannelOttRights: IChannelRightV5[];
  private channelOttRights: IChannelRightV5[];
  private _replayHours = 0;
  channelNumber?: number;
  favorite?: boolean;

  constructor(channel: IChannelV5) {
    Object.assign(this, channel);
    this.customerChannelOttRights = [];
    this.channelOttRights = [];
  }

  channelId!: string;
  enabled!: boolean;
  dvbId?: string | undefined;
  text!: IChannelTextsV5;
  image!: IChannelImagesV5;
  thumbnail?: IChannelThumbnailV5 | undefined;
  audioOnly!: boolean;
  resolution!: string;
  minimumAge?: number | undefined;
  adult!: boolean;
  catalogs?: IChannelCatalogV5[] | undefined;
  parentalControl!: string;

  get maximumRights() {
    return this.channelOttRights;
  }

  get currentCustomerRights() {
    return this.customerChannelOttRights;
  }

  set rights(val: IChannelRightsV5) {
    this.customerChannelOttRights = val.currentRights || [];
    this.channelOttRights = val.maximumRights || [];
  }

  get replayHours() {
    if (this._replayHours) return this._replayHours;
    const right = this.customerChannelOttRights.find(right => right.type === StreamType.REPLAY);
    this._replayHours = right && right.pastHours ? right.pastHours : 0;
    return this._replayHours;
  }

  get npvrRecordHours() {
    const right = this.customerChannelOttRights.find(right => right.type === StreamType.NPVR);
    return right ? right.pastHours : 0;
  }

  customerHasRight(right: StreamType) {
    return this._containsRight(this.customerChannelOttRights, right);
  }

  hasOneOfCustomerRights(rights: StreamType[]) {
    return rights.some(right => this._containsRight(this.customerChannelOttRights, right));
  }

  /**
   * @deprecated do not use, this channel model should have its rights already
   */
  channelHasRightsForStreamTypes(rights: IChannelRightsV5[], streamTypes: StreamType[]): boolean {
    if (!rights || rights.length === 0) {
      return false;
    }

    return rights.some(
      right =>
        right.channelId === this.channelId && right.currentRights?.some(r => streamTypes.includes(r.type as StreamType))
    );
  }

  hasOneofMaxOttRights(search: StreamType[]): boolean {
    return search.some(right => this._containsRight(this.channelOttRights, right));
  }

  /**
   * @private
   */
  _containsRight(rights: IChannelRightV5[], search: StreamType): boolean {
    return rights.some(right => right.type === search);
  }

  findChannelNumber(backend: Backend) {
    if (backend.deviceProfile && this.catalogs) {
      const currentCatalog = backend.deviceProfile.profile.catalog;
      const found = this.catalogs.find(el => el.catalogId === currentCatalog);
      this.channelNumber = found ? found.channelNumber : -1;
    }
  }

  updateFavorite(backend: Backend) {
    const cachedFavApi = backend.cachedFavoriteApi;
    return cachedFavApi.isFavorite(backend, { type: AssetType.CHANNEL, id: this.channelId }).then(res => {
      this.favorite = res;
    });
  }
}
